document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('[data-dunesign-quote-form]');
  const form = wrapper?.querySelector('form');
  if (!form) return;

  const SESSION_STORAGE_KEYS = [
    'dunesign:soft-launch-configuration:v1',
    'dunesignSoftLaunchRequest',
    'dunesign:quote-configuration:v1',
    'dunesign:configurator:v1',
  ];
  const CONTACT_DRAFT_KEY = 'dunesign:soft-launch-contact-draft:v1';
  const REVIEW_SUBMIT_KEY = 'dunesign:soft-launch-review-submit:v1';
  const CONTACT_DRAFT_FIELD_IDS = [
    'DuneSignQuoteForm-name',
    'DuneSignQuoteForm-business',
    'DuneSignQuoteForm-company',
    'DuneSignQuoteForm-invoice-email',
    'DuneSignQuoteForm-invoice-address',
    'DuneSignQuoteForm-postal-code',
    'DuneSignQuoteForm-city',
    'DuneSignQuoteForm-country',
    'DuneSignQuoteForm-kvk',
    'DuneSignQuoteForm-vat-id',
    'DuneSignQuoteForm-reference',
    'DuneSignQuoteForm-email',
    'DuneSignQuoteForm-phone',
    'DuneSignQuoteForm-message',
  ];
  const params = new URLSearchParams(window.location.search);
  const source = params.get('bron');
  let postedFromReviewMode = false;
  let postedFromReviewReferrer = false;
  try {
    postedFromReviewMode = params.get('contact_posted') === 'true'
      && window.sessionStorage.getItem(REVIEW_SUBMIT_KEY) === '1';
  } catch {
    // Als sessieopslag is geblokkeerd, blijft alleen de expliciete configuratorroute actief.
  }
  try {
    const referrer = new URL(document.referrer);
    postedFromReviewReferrer = params.get('contact_posted') === 'true'
      && referrer.origin === window.location.origin
      && referrer.searchParams.get('bron') === 'soft-launch-configurator';
  } catch {
    // Een ontbrekende of ongeldige verwijzer maakt van een normale offerte nooit een controlebestelling.
  }
  const reviewMode = source === 'soft-launch-configurator' || postedFromReviewMode || postedFromReviewReferrer;

  const replaceExactText = (root, original, replacement) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === original) node.nodeValue = node.nodeValue.replace(original, replacement);
    }
  };

  const applyPageMode = () => {
    document.querySelectorAll('[data-ds-quote-mode]').forEach((element) => {
      element.hidden = element.dataset.dsQuoteMode !== (reviewMode ? 'review' : 'quote');
    });
    document.querySelectorAll('[data-ds-quote-only]').forEach((element) => {
      element.hidden = reviewMode;
    });

    const subject = form.querySelector('[data-ds-contact-subject]');
    const submit = form.querySelector('[data-ds-form-submit]');
    const softLaunchNote = form.querySelector('[data-ds-soft-launch-note]');
    if (reviewMode) {
      if (subject) subject.value = 'Nieuwe bestelling ter controle via dunesign.nl';
      if (submit) submit.textContent = 'Persoonlijk voorstel aanvragen →';
      if (softLaunchNote) {
        softLaunchNote.textContent = 'Je betaalt nu nog niets. We controleren je samenstelling en sturen eerst een persoonlijk voorstel. Tot en met €250 betaal je na akkoord volledig; boven €250 start productie na 50% aanbetaling en technische controle.';
      }
      document.title = 'Persoonlijk voorstel aanvragen – Dunesign';
      document.querySelectorAll('a[href*="/pages/offerte-aanvragen"]:not(.dunesign-header-cta):not(.dunesign-menu-drawer-cta)').forEach((link) => {
        replaceExactText(link, 'Offerte', 'Bestelling controleren');
        replaceExactText(link, 'Vrijblijvende aanvraag', 'Persoonlijke controle');
      });
      replaceExactText(document.querySelector('footer'), 'Vrijblijvende aanvraag', 'Persoonlijke controle');
    }
  };

  applyPageMode();

  const locationSelect = form.querySelector('#DuneSignQuoteForm-location');
  const materialSelect = form.querySelector('#DuneSignQuoteForm-material');
  const materialHint = form.querySelector('[data-ds-material-hint]');
  const dateInput = form.querySelector('#DuneSignQuoteForm-date');
  const colorGroups = [...form.querySelectorAll('[data-ds-color-group]')];
  const colorHint = form.querySelector('[data-ds-color-hint]');
  const businessToggle = form.querySelector('[data-ds-business-toggle]');
  const businessPanel = form.querySelector('[data-ds-business-fields]');
  const businessFields = [...form.querySelectorAll('[data-ds-business-field]')];
  const businessRequiredFields = [...form.querySelectorAll('[data-ds-business-required]')];
  let businessValidationAttempted = false;

  const setBusinessFieldError = (field, showError) => {
    const wrapper = field.closest('.dunesign-form__business-field');
    const error = form.querySelector(`[data-ds-business-error="${field.id}"]`);
    wrapper?.classList.toggle('dunesign-form__business-field--invalid', showError);
    field.setAttribute('aria-invalid', showError ? 'true' : 'false');
    field.setCustomValidity(showError ? field.dataset.dsRequiredMessage || 'Vul dit verplichte veld in.' : '');
    if (error) error.hidden = !showError;
  };

  const validateBusinessFields = (focusFirstInvalid = false) => {
    if (!businessToggle?.checked) return true;
    const invalidFields = businessRequiredFields.filter((field) => !field.value.trim());
    businessRequiredFields.forEach((field) => setBusinessFieldError(field, invalidFields.includes(field)));
    if (focusFirstInvalid && invalidFields[0]) {
      invalidFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      invalidFields[0].focus({ preventScroll: true });
    }
    return invalidFields.length === 0;
  };

  const syncBusinessFields = () => {
    const businessOrder = Boolean(businessToggle?.checked);
    if (businessPanel) businessPanel.hidden = !businessOrder;
    businessToggle?.setAttribute('aria-expanded', String(businessOrder));
    businessFields.forEach((field) => {
      field.disabled = !businessOrder;
      field.required = businessOrder && field.hasAttribute('data-ds-business-required');
      if (!businessOrder) setBusinessFieldError(field, false);
    });
  };

  const saveContactDraft = () => {
    const draft = {};
    CONTACT_DRAFT_FIELD_IDS.forEach((id) => {
      const field = form.querySelector(`#${id}`);
      if (field) draft[id] = field.type === 'checkbox' ? field.checked : field.value;
    });
    try {
      window.sessionStorage.setItem(CONTACT_DRAFT_KEY, JSON.stringify(draft));
    } catch {
      console.error('[Dunesign aanvraag] Contactgegevens konden niet tijdelijk worden bewaard.');
    }
  };

  const restoreContactDraft = () => {
    try {
      const draft = JSON.parse(window.sessionStorage.getItem(CONTACT_DRAFT_KEY) || '{}');
      CONTACT_DRAFT_FIELD_IDS.forEach((id) => {
        const field = form.querySelector(`#${id}`);
        if (!field) return;
        if (field.type === 'checkbox' && typeof draft[id] === 'boolean') {
          field.checked = draft[id];
        } else if (!field.value && typeof draft[id] === 'string') {
          field.value = draft[id];
        }
      });
      syncBusinessFields();
    } catch {
      console.error('[Dunesign aanvraag] Contactgegevens konden na de formulierfout niet worden hersteld.');
    }
  };

  const errorFields = [...wrapper.querySelectorAll('[data-ds-form-error-field]')]
    .map((item) => item.dataset.dsFormErrorField)
    .filter(Boolean);

  if (wrapper.querySelector('.dunesign-form__success')) {
    SESSION_STORAGE_KEYS.forEach((key) => {
      try {
        window.sessionStorage.removeItem(key);
      } catch {
        // Opslag kan door browserinstellingen geblokkeerd zijn; de bevestiging blijft gewoon werken.
      }
    });
    try {
      window.sessionStorage.removeItem(CONTACT_DRAFT_KEY);
      window.sessionStorage.removeItem(REVIEW_SUBMIT_KEY);
    } catch {}
    return;
  }

  if (errorFields.length) {
    restoreContactDraft();
    console.error('[Dunesign aanvraag] Shopify contactformulier geweigerd.', {
      fields: errorFields,
      occurredAt: new Date().toISOString(),
    });
  }

  businessToggle?.addEventListener('change', () => {
    businessValidationAttempted = false;
    syncBusinessFields();
  });
  businessRequiredFields.forEach((field) => {
    field.addEventListener('invalid', () => {
      businessValidationAttempted = true;
      setBusinessFieldError(field, true);
    });
    field.addEventListener('input', () => {
      if (field.value.trim()) {
        setBusinessFieldError(field, false);
      } else if (businessValidationAttempted) {
        setBusinessFieldError(field, true);
      }
    });
  });
  form.querySelector('[data-ds-form-submit]')?.addEventListener('click', (event) => {
    businessValidationAttempted = true;
    if (!validateBusinessFields(true)) event.preventDefault();
  });
  form.addEventListener('submit', (event) => {
    businessValidationAttempted = true;
    if (validateBusinessFields(true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  syncBusinessFields();

  if (dateInput) {
    const today = new Date();
    const localToday = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    dateInput.min = localToday;
  }

  const materialForApplication = (application) => {
    if (application === 'Binnen') return 'PLA';
    if (application === 'Buiten' || application === 'Binnen en buiten') return 'PETG';
    if (application === 'Nog niet zeker') return 'Advies gewenst';
    return '';
  };

  const syncColors = (material) => {
    colorGroups.forEach((group) => {
      group.hidden = group.dataset.dsColorGroup !== material;
    });

    const selectedColor = form.querySelector('input[name="contact[Gewenste kleur]"]:checked');
    const selectedGroup = selectedColor?.closest('[data-ds-color-group]');
    if (selectedGroup?.hidden) selectedColor.checked = false;

    if (colorHint) colorHint.hidden = material === 'PLA' || material === 'PETG';
  };

  const syncMaterial = () => {
    if (!materialSelect) return;
    const material = materialForApplication(locationSelect?.value);
    materialSelect.value = material;
    syncColors(material);

    if (!materialHint) return;
    materialHint.textContent =
      material === 'PLA'
        ? 'Automatisch gekozen: PLA voor binnengebruik.'
        : material === 'PETG'
          ? 'Automatisch gekozen: PETG voor buitengebruik.'
          : material === 'Advies gewenst'
            ? 'We adviseren het geschikte materiaal bij de offerte.'
            : 'Bij binnen kiezen we PLA; bij buiten PETG.';
  };

  const valueAtPath = (source, path) => {
    let value = source;
    for (const part of path.split('.')) {
      if (!value || typeof value !== 'object' || !(part in value)) return undefined;
      value = value[part];
    }
    return value;
  };

  const firstValue = (source, paths) => {
    for (const path of paths) {
      const value = valueAtPath(source, path);
      if (value === undefined || value === null) continue;
      if (typeof value === 'string' && !value.trim()) continue;
      return value;
    }
    return '';
  };

  const textValue = (value) => {
    if (value === undefined || value === null) return '';
    if (typeof value === 'boolean') return value ? 'Ja' : 'Nee';
    if (typeof value === 'number' && Number.isFinite(value)) return String(value);
    return typeof value === 'string' ? value : '';
  };

  const numberLabel = (value, suffix, maximumFractionDigits = 6) => {
    if (typeof value === 'number' && Number.isFinite(value)) {
      return `${new Intl.NumberFormat('nl-NL', { maximumFractionDigits }).format(value)} ${suffix}`;
    }
    const label = textValue(value);
    if (!label) return '';
    return new RegExp(`\\b${suffix.replace('/', '\\/')}\\b`, 'i').test(label) ? label : `${label} ${suffix}`;
  };

  const euroLabel = (value, centsValue = '') => {
    const cents = Number(centsValue);
    if (Number.isFinite(cents) && centsValue !== '') {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(value);
    }
    return textValue(value);
  };

  const productLabel = (value) => {
    const normalized = textValue(value).trim().toLowerCase();
    if (['wall-text', 'wall_text', 'wandtekst', 'wandtekst op maat'].includes(normalized)) return 'Wandtekst op maat';
    if (['house', 'house-number', 'house_number', 'huisnummer', 'huisnummer op maat'].includes(normalized)) return 'Huisnummer op maat';
    if (['icon', 'standard-icon', 'standard_icon', 'standaardicoon', 'standaardicoon op maat', 'pictogram', 'pictogram op maat'].includes(normalized)) return 'Pictogram op maat';
    if (['custom', 'maatwerk'].includes(normalized)) return 'Eigen maatwerk';
    return textValue(value);
  };

  const normalizeConfiguration = (stored) => {
    if (!stored || typeof stored !== 'object' || Array.isArray(stored)) return null;
    const nested = firstValue(stored, ['configuration', 'config', 'state', 'quote']);
    const source = nested && typeof nested === 'object' && !Array.isArray(nested)
      ? { ...stored, ...nested }
      : stored;

    const technicalFont = firstValue(source, [
      'technicalFont',
      'technicalFontName',
      'fontTechnicalName',
      'font.family',
      'fontFamily',
    ]);
    const fontWeight = firstValue(source, ['fontWeight', 'weight', 'font.weight']);
    const rateCents = firstValue(source, ['rateCents', 'pricePerCmCents', 'pricing.rateCents']);
    const rateUnit = textValue(firstValue(source, ['rateUnit', 'pricing.rateUnit'])).toLowerCase();
    const rateCentsPerCm = firstValue(source, ['rateCentsPerCm', 'pricePerCmCents', 'pricing.rateCentsPerCm']);
    const rateCentsPerCharacter = firstValue(source, [
      'rateCentsPerCharacter',
      'pricePerCharacterCents',
      'pricing.rateCentsPerCharacter',
    ]);
    const hasRateCentsPerCm = rateCentsPerCm !== '';
    const hasRateCentsPerCharacter = rateCentsPerCharacter !== '';
    const productPriceCents = firstValue(source, ['productPriceCents', 'pricing.productPriceCents']);
    const originalProductPriceCents = firstValue(source, ['originalProductPriceCents', 'pricing.originalProductPriceCents']);
    const lengthAdvantageCents = firstValue(source, ['lengthAdvantageCents', 'pricing.lengthAdvantageCents']);
    const mountingPriceCents = firstValue(source, ['mountingPriceCents', 'pricing.mountingPriceCents']);
    const totalPriceCents = firstValue(source, ['totalPriceCents', 'totalCents', 'finalTotalCents', 'pricing.totalPriceCents', 'pricing.totalCents']);
    const minimumApplied = firstValue(source, ['minimumApplied', 'minimumPriceApplied', 'pricing.minimumApplied']);
    const rawProduct = firstValue(source, ['productTitle', 'productRoute', 'route', 'productType', 'type', 'product']);
    const normalizedProduct = productLabel(rawProduct);
    const suffixRateCents = firstValue(source, ['suffixRateCents', 'pricing.suffixRateCents']);
    const suffixPriceCents = firstValue(source, ['suffixPriceCents', 'pricing.suffixPriceCents']);

    const configuration = {
      mode: 'Soft launch — persoonlijke controle',
      schemaVersion: textValue(firstValue(source, ['schemaVersion', 'version'])) || 'soft-launch-v1',
      configurationId: textValue(firstValue(source, ['configurationId', 'configId', 'id'])),
      product: normalizedProduct,
      text: textValue(firstValue(source, ['fullText', 'text', 'enteredText', 'number', 'design', 'ontwerp'])),
      chosenIcon: textValue(firstValue(source, ['chosenIcon', 'iconTitle', 'icon.label', 'icon.name'])),
      friendlyFont: textValue(firstValue(source, [
        'friendlyFont',
        'friendlyFontName',
        'fontFriendlyName',
        'font.label',
        'font.title',
        'styleTitle',
      ])),
      technicalFont: textValue(technicalFont),
      fontWeight: textValue(fontWeight),
      color: textValue(firstValue(source, ['colorFriendlyName', 'colorName', 'color.label', 'color.name', 'color'])),
      technicalColor: textValue(firstValue(source, ['colorTechnicalName', 'technicalColor', 'color.technicalName'])),
      letterHeight: numberLabel(firstValue(source, ['letterHeightCm', 'heightCm', 'letterHeight', 'height', 'length', 'size']), 'cm'),
      thickness: numberLabel(firstValue(source, ['thicknessMm', 'thickness', 'dikte']), 'mm'),
      material: textValue(firstValue(source, ['materialLabel', 'material.label', 'material'])),
      application: textValue(firstValue(source, ['application', 'applicationLabel', 'use', 'toepassing'])),
      surfaceCategory: textValue(firstValue(source, ['surfaceCategory', 'surfaceTitle', 'surface.category', 'ondergrondcategorie'])),
      substrate: textValue(firstValue(source, ['substrate', 'surface.substrate', 'surfaceType', 'soortOndergrond'])),
      actualWidth: numberLabel(firstValue(source, ['actualWidthCm', 'calculatedWidthCm', 'actualWidth', 'widthCm', 'width']), 'cm'),
      actualWidthFriendly: numberLabel(firstValue(source, ['actualWidthCm', 'calculatedWidthCm', 'actualWidth', 'widthCm', 'width']), 'cm', 1),
      billableWidth: numberLabel(firstValue(source, ['billableWidthCm', 'paidWidthCm', 'roundedWidthCm', 'billableWidth']), 'cm'),
      iconWidth: numberLabel(firstValue(source, ['iconWidthCm', 'iconDimensions.widthCm', 'icon.widthCm']), 'cm'),
      iconHeight: numberLabel(firstValue(source, ['iconHeightCm', 'iconDimensions.heightCm', 'icon.heightCm']), 'cm'),
      ratePerCm: rateUnit === 'cm' || hasRateCentsPerCm
        ? euroLabel(
          firstValue(source, ['ratePerCm', 'pricePerCm', 'pricing.ratePerCm']),
          hasRateCentsPerCm ? rateCentsPerCm : rateCents,
        )
        : normalizedProduct === 'Wandtekst op maat' && !rateUnit
          ? euroLabel(firstValue(source, ['ratePerCm', 'pricePerCm', 'pricing.ratePerCm']), rateCents)
          : '',
      ratePerCharacter: rateUnit === 'character' || hasRateCentsPerCharacter
        ? euroLabel(
          firstValue(source, ['ratePerCharacter', 'pricePerCharacter', 'pricing.ratePerCharacter']),
          hasRateCentsPerCharacter ? rateCentsPerCharacter : rateCents,
        )
        : normalizedProduct === 'Huisnummer op maat' && !rateUnit
          ? euroLabel(firstValue(source, ['ratePerCharacter', 'pricePerCharacter', 'pricing.ratePerCharacter']), rateCents)
          : '',
      detectedSuffix: textValue(firstValue(source, ['detectedSuffix', 'suffixCharacter', 'houseSuffix'])),
      suffixSizeMode: textValue(firstValue(source, ['suffixSizeMode', 'suffixMode', 'houseSuffixMode'])),
      suffixHeight: numberLabel(firstValue(source, ['suffixHeightCm', 'houseSuffixHeightCm']), 'cm', 2),
      suffixWidthScale: textValue(firstValue(source, ['suffixWidthScale', 'houseSuffixScale'])),
      suffixThickness: numberLabel(firstValue(source, ['suffixThicknessMm', 'houseSuffixThicknessMm']), 'mm'),
      fullPriceCharacters: textValue(firstValue(source, ['fullPriceCharacters', 'fullCharacterCount'])),
      suffixRate: euroLabel(firstValue(source, ['suffixRate', 'pricing.suffixRate']), suffixRateCents),
      suffixPrice: euroLabel(firstValue(source, ['suffixPrice', 'pricing.suffixPrice']), suffixPriceCents),
      minimumApplied: typeof minimumApplied === 'boolean'
        ? minimumApplied ? 'Ja, minimumprijs van € 17,95 toegepast' : 'Nee'
        : textValue(minimumApplied),
      productPrice: euroLabel(firstValue(source, ['productPrice', 'productTotal', 'pricing.productPrice']), productPriceCents),
      productPriceCents: textValue(productPriceCents),
      originalProductPrice: euroLabel('', originalProductPriceCents),
      originalProductPriceCents: textValue(originalProductPriceCents),
      lengthAdvantage: Number(lengthAdvantageCents) > 0 ? euroLabel('', lengthAdvantageCents) : '',
      lengthAdvantageCents: textValue(lengthAdvantageCents),
      mountingPrice: euroLabel(firstValue(source, ['mountingPrice', 'pricing.mountingPrice']), mountingPriceCents),
      mountingPriceCents: textValue(mountingPriceCents),
      totalPrice: euroLabel(firstValue(source, ['totalPrice', 'total', 'finalTotal', 'pricing.totalPrice', 'pricing.total']), totalPriceCents),
      totalPriceCents: textValue(totalPriceCents),
      mounting: textValue(firstValue(source, ['mountingLabel', 'mountingChoice', 'mounting', 'mountTitle', 'mount', 'bevestiging'])),
      variantId: textValue(firstValue(source, ['variantId', 'shopifyVariantId', 'variant.id'])),
      iconVariantId: textValue(firstValue(source, ['iconVariantId', 'icon.variantId'])),
      mountingVariantId: textValue(firstValue(source, ['mountingVariantId', 'mounting.variantId', 'mount.variantId'])),
      rateVersion: textValue(firstValue(source, ['rateVersion', 'pricingVersion', 'pricing.version'])),
    };

    if (['Standaardicoon op maat', 'Pictogram op maat'].includes(configuration.product)) {
      configuration.friendlyFont = '';
      configuration.technicalFont = '';
      configuration.fontWeight = '';
    }

    if (configuration.ratePerCm && !/(?:\bper\s+cm\b|\/\s*cm\b)/i.test(configuration.ratePerCm)) {
      configuration.ratePerCm = `${configuration.ratePerCm} per cm`;
    }
    if (configuration.ratePerCharacter && !/per\s+teken/i.test(configuration.ratePerCharacter)) {
      configuration.ratePerCharacter = `${configuration.ratePerCharacter} per volledig teken`;
    }

    if (!configuration.product && !configuration.text) return null;
    return configuration;
  };

  const readStoredConfiguration = () => {
    for (const key of SESSION_STORAGE_KEYS) {
      try {
        const raw = window.sessionStorage.getItem(key);
        if (!raw) continue;
        const configuration = normalizeConfiguration(JSON.parse(raw));
        if (configuration) return configuration;
      } catch {
        // Ongeldige of geblokkeerde sessiegegevens worden genegeerd; het algemene formulier blijft beschikbaar.
      }
    }
    return null;
  };

  const applyStoredConfiguration = (configuration) => {
    const summary = form.querySelector('[data-ds-config-summary]');
    if (!summary) return false;

    summary.hidden = false;
    const customerProduct = form.querySelector('[data-ds-customer-product]');
    const customerDesign = form.querySelector('[data-ds-customer-design]');
    const customerDimensions = form.querySelector('[data-ds-customer-dimensions]');
    const customerFinish = form.querySelector('[data-ds-customer-finish]');
    const customerMounting = form.querySelector('[data-ds-customer-mounting]');
    const customerTotal = form.querySelector('[data-ds-customer-total]');
    const customerAdvantage = form.querySelector('[data-ds-customer-advantage]');
    const customerProductLabels = {
      'Wandtekst op maat': 'Jouw wandtekst',
      'Huisnummer op maat': 'Jouw huisnummer',
      'Pictogram op maat': 'Jouw pictogram',
    };
    const design = configuration.text || configuration.chosenIcon;
    if (customerProduct) customerProduct.textContent = customerProductLabels[configuration.product] || 'Jouw samenstelling';
    if (customerDesign) customerDesign.textContent = configuration.text ? `“${configuration.text}”` : design;
    if (customerDimensions) {
      if (configuration.iconWidth && configuration.iconHeight) {
        customerDimensions.textContent = `${configuration.iconWidth} × ${configuration.iconHeight}`;
      } else {
        customerDimensions.textContent = [
          configuration.letterHeight && `${configuration.letterHeight} hoog`,
          (configuration.actualWidthFriendly || configuration.actualWidth) && `${configuration.actualWidthFriendly || configuration.actualWidth} breed`,
        ].filter(Boolean).join(' · ');
      }
    }
    if (customerFinish) {
      const application = configuration.application ? configuration.application.toLowerCase() : '';
      customerFinish.textContent = [
        configuration.color,
        configuration.material && application ? `${configuration.material} voor ${application}` : configuration.material,
      ].filter(Boolean).join(' · ');
    }
    if (customerMounting) customerMounting.textContent = configuration.mounting;
    if (customerTotal) customerTotal.textContent = configuration.totalPrice ? `${configuration.totalPrice} incl. btw` : '';
    if (customerAdvantage) {
      customerAdvantage.hidden = !configuration.lengthAdvantage;
      customerAdvantage.textContent = configuration.lengthAdvantage
        ? customerAdvantage.dataset.dsAdvantageTemplate.replace('__amount__', configuration.lengthAdvantage)
        : '';
    }

    const technicalDetails = form.querySelector('[data-ds-technical-details]');
    if (technicalDetails) technicalDetails.open = false;
    form.querySelectorAll('[data-ds-summary-row]').forEach((row) => {
      const key = row.dataset.dsSummaryRow;
      const value = configuration[key] || '';
      row.hidden = !value;
      const output = row.querySelector('[data-ds-summary-value]');
      if (output) output.textContent = value;
    });

    form.querySelectorAll('[data-ds-contact-field]').forEach((input) => {
      const key = input.dataset.dsContactField;
      input.value = configuration[key] || '';
      input.disabled = !input.value;
    });

    const generalFields = form.querySelector('[data-ds-general-fields]');
    if (generalFields) {
      generalFields.hidden = true;
      generalFields.querySelectorAll('input, select, textarea, button').forEach((field) => {
        field.disabled = true;
      });
    }

    return true;
  };

  locationSelect?.addEventListener('change', syncMaterial);
  materialSelect?.addEventListener('change', () => syncColors(materialSelect.value));
  syncMaterial();

  form.addEventListener('submit', () => {
    saveContactDraft();
    try {
      if (reviewMode) window.sessionStorage.setItem(REVIEW_SUBMIT_KEY, '1');
      else window.sessionStorage.removeItem(REVIEW_SUBMIT_KEY);
    } catch {
      console.error('[Dunesign aanvraag] De tijdelijke bevestigingsmodus kon niet worden bewaard.');
    }
    form.querySelectorAll('[data-ds-omit-if-empty]').forEach((field) => {
      if (!field.value.trim()) field.disabled = true;
    });
  });

  if (reviewMode) {
    const storedConfiguration = readStoredConfiguration();
    if (storedConfiguration && applyStoredConfiguration(storedConfiguration)) return;

    const missingConfiguration = form.querySelector('[data-ds-review-missing]');
    const submit = form.querySelector('[data-ds-form-submit]');
    if (missingConfiguration) missingConfiguration.hidden = false;
    if (submit) submit.disabled = true;
    return;
  }

  if (!['configurator', 'oplossingen'].includes(source)) return;

  const values = {
    type: params.get('type') || '',
    ontwerp: params.get('ontwerp') || '',
    formaat: params.get('formaat') || '',
    toepassing: params.get('toepassing') || '',
    kleur: params.get('kleur') || '',
    bevestiging: params.get('bevestiging') || '',
    stijl: params.get('stijl') || '',
    materiaal: params.get('materiaal') || '',
    lengte: params.get('lengte') || '',
    breedte: params.get('breedte') || '',
    dikte: params.get('dikte') || '',
  };

  const typeSelect = form.querySelector('#DuneSignQuoteForm-type');
  const knownType = [...(typeSelect?.options || [])].some((option) => option.value === values.type);
  if (typeSelect && values.type) typeSelect.value = knownType ? values.type : 'Anders / nog niet zeker';

  if (locationSelect && values.toepassing) {
    locationSelect.value = values.toepassing;
    syncMaterial();
  }

  if (materialSelect && values.materiaal) materialSelect.value = values.materiaal;

  for (const [key, value] of Object.entries(values)) {
    const input = form.querySelector(`[data-ds-prefill="${key}"]`);
    if (input) input.value = value;
  }

  if (source === 'oplossingen') return;

  const lines = [
    'Keuzes uit de configurator:',
    values.type && `Type: ${values.type}`,
    values.ontwerp && `Ontwerp: ${values.ontwerp}`,
    values.formaat && `Formaat: ${values.formaat}`,
    values.lengte && `Lengte / hoogte: ${values.lengte} cm`,
    values.breedte && `Breedte: ${values.breedte} cm`,
    values.dikte && `Dikte: ${values.dikte} mm`,
    values.toepassing && `Toepassing: ${values.toepassing}`,
    values.materiaal && `Materiaal: ${values.materiaal}`,
    values.kleur && `Kleur: ${values.kleur}`,
    values.stijl && `Lettertype: ${values.stijl}`,
    values.bevestiging && `Bevestiging: ${values.bevestiging}`,
  ].filter(Boolean);

  const message = form.querySelector('#DuneSignQuoteForm-message');
  if (message && !message.value.trim()) message.value = `${lines.join('\n')}\n\nAanvullende toelichting:\n`;
});
